export default "__VITE_ASSET__66d1ea2b__"